import { Link } from 'react-router-dom';

export default function WishlistFooter() {
  return (
    <footer className="bg-stone-900 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-4 group">
            <img
              src="https://static.readdy.ai/image/bff3983fcac7598cf15bb5173700e0d7/b58838733802ef1d20431284565f42b3.jpeg"
              alt="House of FMR"
              className="h-16 w-16 object-contain"
            />
            <div>
              <p className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-yellow-100 to-amber-300 font-serif text-lg font-semibold">
                House of FMR
              </p>
              <p className="text-amber-400 text-xs tracking-wider uppercase">
                Events & Styling
              </p>
            </div>
          </Link>

          {/* Links */}
          <div className="flex items-center gap-8">
            <Link to="/" className="text-stone-400 hover:text-amber-400 transition-colors text-sm">
              Home
            </Link>
            <Link to="/gallery" className="text-stone-400 hover:text-amber-400 transition-colors text-sm">
              Gallery
            </Link>
            <Link to="/wishlist" className="text-amber-400 text-sm">
              Wishlist
            </Link>
          </div>

          {/* Social */}
          <div className="flex items-center gap-3">
            {['instagram', 'facebook', 'twitter', 'youtube'].map((social) => (
              <a
                key={social}
                href="#"
                className="w-10 h-10 rounded-full bg-stone-800 flex items-center justify-center text-stone-400 hover:bg-amber-400 hover:text-stone-900 transition-all cursor-pointer"
              >
                <i className={`ri-${social}-line text-lg`}></i>
              </a>
            ))}
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-stone-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-stone-500 text-sm">
            © 2025 House of FMR Mixology. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="text-stone-500 hover:text-amber-400 transition-colors text-sm"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
